import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminSetup.css';
import API_BASE_URL from '../../config';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GroupIcon from '@mui/icons-material/Group';
import TuneIcon from '@mui/icons-material/Tune';
import SettingsIcon from '@mui/icons-material/Settings';
import LanIcon from '@mui/icons-material/Lan';
import CellTowerIcon from '@mui/icons-material/CellTower';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { Button, MenuItem, Select, InputLabel, FormControl, TextField, Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';

import topBoardImage from '../../assets/setup/top_board.png';
import bottomBoardImage from '../../assets/setup/lower_board.png';
import internetImage from '../../assets/setup/internet.png';
import batteryConnectionImage from '../../assets/setup/battery_connection.png';
import winRImage from '../../assets/setup/win_r.png';
import controlPanelImage from '../../assets/setup/control_panel.png';
import ethernetStatusImage from '../../assets/setup/ethernet_status.png';
import ipv4Image from '../../assets/setup/ipv4.png';
import ipAddrImage from '../../assets/setup/ipaddr.png';
import ledCenterImage from '../../assets/setup/ledcenter.png';
import findImage from '../../assets/setup/find.png';
import addNewImage from '../../assets/setup/add_new.png';
import screenTestImage from '../../assets/setup/screen_test.png';
import screenTest2Image from '../../assets/setup/screen_test2.png';
import openLedToolImage from '../../assets/setup/open_ledtool.png';
import screenEditorImage from '../../assets/setup/screen_editor.png';
import hardwareParametersImage from '../../assets/setup/hardware_parameters.png';
import wifiImage from '../../assets/setup/wifi.png';
import timeSyncImage from '../../assets/setup/time_sync.png';
import cPowerImage from '../../assets/setup/cpower.png';
import cpToolImage from '../../assets/setup/cptool.png';
import blackImage from '../../assets/setup/black.png';
import pushBlackImage from '../../assets/setup/push_black.png';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorIcon from '@mui/icons-material/Error';
import SignalCellular0BarIcon from '@mui/icons-material/SignalCellular0Bar';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import SignalCellular2BarIcon from '@mui/icons-material/SignalCellular2Bar';
import SignalCellular3BarIcon from '@mui/icons-material/SignalCellular3Bar';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';
import SignalCellularConnectedNoInternet0BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet0Bar';


const AdminSetup = () => {
    const contentRef = useRef(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [selectedDeviceType, setSelectedDeviceType] = useState('');
    const [deviceID, setDeviceID] = useState('');
    const [deviceIP, setDeviceIP] = useState('');
    const [direction, setDirection] = useState('');
    const [description, setDescription] = useState('');
    const [selectedBatterySize, setSelectedBatterySize] = useState('');
    const [selectedSolarSize, setSelectedSolarSize] = useState('');
    const [streetAddress, setStreetAddress] = useState('');
    const [suburb, setSuburb] = useState('');
    const [state, setState] = useState('');
    const [postcode, setPostcode] = useState('');
    const [country, setCountry] = useState('');
    const [builtDate, setBuiltDate] = useState(new Date());
    const [warrantyDate, setWarrantyDate] = useState(null);
    const [servicePlanDate, setServicePlanDate] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [deviceTypes, setDeviceTypes] = useState([]);
    const [batterySizes, setBatterySizes] = useState([]);
    const [solarSizes, setSolarSizes] = useState([]);
    const [error, setError] = useState('');
    const [step3Complete, setStep3Complete] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [step4Complete, setStep4Complete] = useState(false);
    const [deviceMac, setDeviceMac] = useState('');
    const [step5Complete, setStep5Complete] = useState(false);
    const [configs, setConfigs] = useState({});
    const [step6Complete, setStep6Complete] = useState(false);
    const [ipOctets, setIpOctets] = useState(['', '', '', '']);
    const [registrationInProgress, setRegistrationInProgress] = useState(false);
    const [processSteps, setProcessSteps] = useState([]);
    const [deviceInfo, setDeviceInfo] = useState(null);
    const REGISTRATION_PROCESSES = [
        'Creating new device',
        'Registering new device to server',
        'Initializing device',
        'Turn screen brightness to the lowest setting',
        'Turn screen brightness to the highest setting',
        'Turn off screen',
        'Turn on screen',
        'Reading device versions',
        'Reading storage space',
        'Reading datetime',
        'Reading temperature',
        'Reading GPS coordinates',
        'Reading 4G signal strength',
        'Reading screen position',
        'Reading door sensor status',
        'Reading battery details'
    ];
    const [processStatuses, setProcessStatuses] = useState(
        Object.fromEntries(REGISTRATION_PROCESSES.map(process => [process, 'pending']))
    );
    const [processResponses, setProcessResponses] = useState({});

    const [isOnline, setIsOnline] = useState(false);
    const [checking, setChecking] = useState(false);
    const [checkMessage, setCheckMessage] = useState("Please complete connection check before registration.");
    const [longitude, setLongitude] = useState('');
    const [latitude, setLatitude] = useState('');
    const [resultDialog, setResultDialog] = useState({ open: false, success: false, message: '' });


    const navigate = useNavigate();

    useEffect(() => {
        const fetchSetupData = async () => {
            try {
            const response = await fetch(`${API_BASE_URL}/admin/setup-data`, {
                headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setCustomers(data.customers);
                setDeviceTypes(data.deviceTypes);
                setBatterySizes(data.batterySizes);
                setSolarSizes(data.solarSizes);
                setConfigs(data.configs);
            } else if (response.status === 401) {
                navigate('/unauthorized');
            } else {
                setError('Failed to fetch setup data');
            }
            } catch (error) {
            console.error('Error:', error);
            setError('An error occurred. Please try again.');
            }
        };

        fetchSetupData();
        }, [navigate]);

        useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        }, [currentStep]);

        const handleCustomerChange = (e) => {
        setSelectedCustomer(e.target.value);
        };

        const handleDeviceTypeChange = (e) => {
        setSelectedDeviceType(e.target.value);
        };

        const handleBatterySizeChange = (e) => {
        setSelectedBatterySize(e.target.value);
        };

        const handleSolarSizeChange = (e) => {
        setSelectedSolarSize(e.target.value);
        };

        const handleServicePlanDateChange = (date) => {
        setServicePlanDate(date);
        if (warrantyDate && date > warrantyDate) {
            setWarrantyDate(date);
        }
        };

        const handleContinue = () => {
        if (currentStep < steps.length) {
            setCurrentStep(currentStep + 1);
        }
        };

        const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
        };

        const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
        };

        const handleClosePopup = () => {
        setSelectedImage(null);
        };

        const handleCheckInternet = async () => {
            setChecking(true);
            setCheckMessage("");
            try {
                const response = await fetch(`${API_BASE_URL}/admin/device-connection/${deviceID}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const data = await response.json();

                    if (data.device_id === deviceID) {
                        setIsOnline(true);
                        setCheckMessage("Device is connected to the internet.");
                    } else {
                        setIsOnline(false);
                        setCheckMessage("Device is not connected. Please check again later.");
                    }
                } else {
                    setIsOnline(false);
                    setCheckMessage("Device is not connected. Please check again later.");
                }
            } catch (error) {
                console.error('Error checking connection:', error);
                setIsOnline(false);
                setCheckMessage("Error checking connection. Try again later.");
            }
            setChecking(false);
        };

        const steps = [
            { title: 'Register Inspection Unit', description: '', icon: <SettingsIcon /> }
        ];

        const isStepComplete = () => {
            switch (currentStep) {
                default:
                    return true;
            }
        };

        // Add handler for IP octet changes
        const handleIpOctetChange = (index, value) => {
        if (value === '' || (parseInt(value) >= 0 && parseInt(value) <= 255)) {
            const newOctets = [...ipOctets];
            newOctets[index] = value;
            setIpOctets(newOctets);
            setDeviceIP(newOctets.join('.'));
        }
        };

        const validateRegistration = () => {
            const requiredFields = {
                selectedCustomer,
                deviceID,
                description,
                streetAddress,
                suburb,
                longitude,
                latitude
            };
            return Object.entries(requiredFields).every(([, value]) =>
                value !== undefined && value !== null && String(value).trim() !== ''
            );
        };
        

        const resetRegistrationForm = () => {
            setSelectedCustomer('');
            setDeviceID('');
            setDescription('');
            setStreetAddress('');
            setSuburb('');
            setLongitude('');
            setLatitude('');
            setError('');
        };

        const handleRegisterDevice = async () => {
            if (!validateRegistration()) {
                setError('Please fill in all required fields');
                return;
            }
            const payload = {
                userId: selectedCustomer,
                deviceId: deviceID,
                description,
                address: {
                    streetAddress,
                    suburb
                },
                longitude,
                latitude
            };

            setError('');
            setRegistrationInProgress(true);

            try {
                const response = await fetch(`${API_BASE_URL}/admin/register-inspection-device`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                const data = await response.json().catch(() => ({}));

                if (response.ok && data.success) {
                    resetRegistrationForm();
                    setResultDialog({
                        open: true,
                        success: true,
                        message: data.message || 'Inspection device registered successfully.'
                    });
                } else {
                    setResultDialog({
                        open: true,
                        success: false,
                        message: data.message || 'Registration failed.'
                    });
                }
            } catch (error) {
                console.error('Error:', error);
                setResultDialog({
                    open: true,
                    success: false,
                    message: 'Registration failed. Please try again.'
                });
            } finally {
                setRegistrationInProgress(false);
            }
        };

      const getSignalStrength = (dBm) => {
        if (!dBm || dBm === 99) return -1;
        
        const strength = parseInt(dBm);
        if (strength >= -70) return 4;
        if (strength >= -85) return 3;
        if (strength >= -100) return 2;
        if (strength >= -110) return 1;
        return 0;
      };
      
      const getSignalIcon = (dBm) => {
        const strength = getSignalStrength(dBm);
        
        const icons = {
            0: <SignalCellular0BarIcon sx={{ color: '#ff9800' }}/>,
            1: <SignalCellular1BarIcon sx={{ color: '#ff9800' }}/>,
            2: <SignalCellular2BarIcon sx={{ color: '#4caf50' }}/>,
            3: <SignalCellular3BarIcon sx={{ color: '#4caf50' }}/>,
            4: <SignalCellular4BarIcon sx={{ color: '#4caf50' }}/>
          };
          return icons[strength] || <SignalCellularConnectedNoInternet0BarIcon sx={{ color: '#f44336' }}/>;
      };
      
      // Update process item rendering
      const renderProcessResponse = (process, response) => {
        if (!response) return null;
        if (process === 'Reading 4G signal strength') {
            const strengthValue = parseInt(response.strength);
            const signalData = getSignalStrength(strengthValue);
            
            return (
              <div className="process-response">
                <div className="response-grid">
                    <div className="response-item">
                    <span className="response-key">Signal Strength:</span>
                    <span className="response-value">
                        {getSignalIcon(strengthValue)}
                        {response.strength}
                    </span>
                    </div>
                    <div className="response-item">
                    <span className="response-key">Network Mode:</span>
                    <span className="response-value">{response.mode}</span>
                    </div>
                </div>
              </div>
            );
        }
        return (
          <div className="process-response">
            {typeof response === 'object' ? (
              <div className="response-grid">
                {Object.entries(response).map(([key, value]) => (
                  <div key={key} className="response-item">
                    <span className="response-key">{key}:</span>
                    <span className="response-value">{value}</span>
                  </div>
                ))}
              </div>
            ) : (
              <span className="response-text">{response}</span>
            )}
          </div>
        );
    };

    const handleSetupComplete = () => {
        navigate('/admin/dashboard');
    };



    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="admin-setup-container">
            <div className="setup-area" ref={contentRef} style={{ width: '100%', marginLeft: 0, maxWidth: 720, margin: '0 auto' }}>
                <h4 className="step-name">Register Inspection Unit</h4>
                <div className="step-content">
                    <FormControl fullWidth variant="outlined">
                    <InputLabel id="customer-select-label">Select Customer</InputLabel>
                    <Select
                        labelId="customer-select-label"
                        id="customer-select"
                        value={selectedCustomer}
                        onChange={handleCustomerChange}
                        label="Select Customer"
                        style={{ backgroundColor: '#fff' }}
                    >
                        {customers.map((customer) => (
                        <MenuItem key={customer.id} value={customer.id}>
                            {customer.org_name}
                        </MenuItem>
                        ))}
                    </Select>
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Device ID"
                        value={deviceID}
                        onChange={(e) => setDeviceID(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Street Address"
                        value={streetAddress}
                        onChange={(e) => setStreetAddress(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Suburb"
                        value={suburb}
                        onChange={(e) => setSuburb(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Longitude"
                        value={longitude}
                        onChange={(e) => setLongitude(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Latitude"
                        value={latitude}
                        onChange={(e) => setLatitude(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    </FormControl>
                    {error && <p className="error">{error}</p>}
                </div>
                
                <div className="navigation-buttons">
                    <Button
                            variant="contained"
                            disabled={!validateRegistration() || registrationInProgress}
                            onClick={handleRegisterDevice}
                            style={{
                                backgroundColor: validateRegistration() && !registrationInProgress ? 'rgba(76, 175, 80)' : '#555',
                                color: 'white'
                            }}
                        >
                            {registrationInProgress ? 'Registering...' : 'Register'}
                        </Button>
                    </div>
                </div>
            </div>
            <Dialog
                open={resultDialog.open}
                onClose={() => setResultDialog((prev) => ({ ...prev, open: false }))}
            >
                <DialogTitle sx={{ color: resultDialog.success ? '#2e7d32' : '#c62828' }}>
                    {resultDialog.success ? 'Successful' : 'Failed'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {resultDialog.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setResultDialog((prev) => ({ ...prev, open: false }))}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
};

export default AdminSetup;